module.exports = __webpack_public_path__ + "static/media/logo-super.33a04220.svg";